<section class="create-ca">
  <h1 class="create-ca__title">{{labels.title}}</h1>
  <form [formGroup]="form" class="create-ca__body" appFormFields>
    <div class="create-ca__inputs">
      <app-form-field [name]="CaFullFormField.caType" class="create-ca__catype"></app-form-field>
      <app-form-field [name]="CaFullFormField.cryptoTokenType"></app-form-field>
      <app-form-field [name]="CaFullFormField.cryptoTokenName" [options]="cryptoTokenNameOptions()"></app-form-field>
      <app-form-field [name]="CaFullFormField.password" class="create-ca__password"></app-form-field>
      <app-form-field [name]="CaFullFormField.dn" class="create-ca__dn"></app-form-field>
      <app-form-field [name]="CaFullFormField.signedBy" [options]="signedByOptions()"></app-form-field>
      <app-form-field [name]="CaFullFormField.signingAlgo" [options]="signingAlgos"></app-form-field>
      <!--
      <app-form-field [name]="CaFullFormField.keyAlgorithm"></app-form-field>
      -->
      <app-form-field [name]="CaFullFormField.keySpecification"></app-form-field>
      <app-form-field [name]="CaFullFormField.validityYears" [options]="validityYearsOptions"></app-form-field>
      <app-form-field [name]="CaFullFormField.certificateMaxValidityYears" [options]="certificateMaxValidityYears()"></app-form-field>
      <app-form-field [name]="CaFullFormField.profileName"></app-form-field>
      <app-form-field [name]="CaFullFormField.caCertificateProfile" [options]="caCertificateProfileOptions()"></app-form-field>
      <app-form-field [name]="CaFullFormField.useLdapDnOrder"></app-form-field>
    </div>
    <div class="create-ca__buttons">
      <button mat-button type="button" class="button" (click)="onCancel()">{{labels.buttons.cancel}}</button>
      <button mat-button type="submit" class="button button_primary" (click)="onCreate()">{{labels.buttons.create}}</button>
    </div>
  </form>
</section>
